/** Intenção do login: colaborador de loja vs equipe interna (/dev). */

export const LOGIN_AUDIENCE_STORAGE_KEY = "delivai_login_audience";

export type LoginAudience = "empresa" | "colaboradores" | "delivai_dev";

export function persistLoginAudience(audience: LoginAudience): void {
  try {
    localStorage.setItem(LOGIN_AUDIENCE_STORAGE_KEY, audience);
  } catch {
    /* ignore */
  }
}

export function readLoginAudience(): LoginAudience | null {
  try {
    const v = localStorage.getItem(LOGIN_AUDIENCE_STORAGE_KEY);
    if (v === "empresa" || v === "colaboradores" || v === "delivai_dev") return v;
  } catch {
    /* ignore */
  }
  return null;
}

export function clearLoginAudience(): void {
  try {
    localStorage.removeItem(LOGIN_AUDIENCE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function parseAgendaEnabledFlag(value: unknown): boolean {
  return value === true || value === "true" || value === 1 || value === "1";
}
